import type { FormatterType } from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/getFormatterType";
import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";

// Written as a boolean, `expanded` reached the file as an empty attribute that reads back as closed.
const isCollapsed = (expanded: unknown) => expanded === false || expanded === "false" || expanded === "";

const inlineCutFormatter =
	(formatter: FormatterType): NodeSerializerSpec =>
	async (state, node) => {
		state.write(
			formatter.openTag("cut", {
				text: node.attrs.text,
				...(isCollapsed(node.attrs.expanded) ? { expanded: "false" } : {}),
			}),
		);
		await state.renderContent(node);
		state.write(formatter.closeTag("cut"));
	};

export default inlineCutFormatter;
